// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistantsalesorder_positions_koestnerwarnings_noproductcertificates5 = /** @type {(inputs: { requestedCertificate: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The customer requested the certificate "${i?.requestedCertificate}", however this product has no defined certificates in the master data.`)
};

const en_us2_assistantsalesorder_positions_koestnerwarnings_noproductcertificates5 = /** @type {(inputs: { requestedCertificate: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The customer requested the certificate "${i?.requestedCertificate}", however this product has no defined certificates in the master data.`)
};

const de_de2_assistantsalesorder_positions_koestnerwarnings_noproductcertificates5 = /** @type {(inputs: { requestedCertificate: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Kunde fragt Zeugnis "${i?.requestedCertificate}" an, dieses Produkt hat allerdings kein Zeugnis in den Stammdaten hinterlegt.`)
};

const en_assistantsalesorder_positions_koestnerwarnings_noproductcertificates5 = /** @type {(inputs: { requestedCertificate: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The customer requested the certificate "${i?.requestedCertificate}", however this product has no defined certificates in the master data.`)
};

const de_assistantsalesorder_positions_koestnerwarnings_noproductcertificates5 = /** @type {(inputs: { requestedCertificate: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Kunde fragt Zeugnis "${i?.requestedCertificate}" an, dieses Produkt hat allerdings kein Zeugnis in den Stammdaten hinterlegt.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ requestedCertificate: NonNullable<unknown> }} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistantsalesorder_positions_koestnerwarnings_noproductcertificates5 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistantsalesorder_positions_koestnerwarnings_noproductcertificates5(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistantsalesorder_positions_koestnerwarnings_noproductcertificates5", locale)
	if (locale === "en-GB") return en_gb2_assistantsalesorder_positions_koestnerwarnings_noproductcertificates5(inputs)
	if (locale === "en-US") return en_us2_assistantsalesorder_positions_koestnerwarnings_noproductcertificates5(inputs)
	if (locale === "de-DE") return de_de2_assistantsalesorder_positions_koestnerwarnings_noproductcertificates5(inputs)
	if (locale === "en") return en_assistantsalesorder_positions_koestnerwarnings_noproductcertificates5(inputs)
	return de_assistantsalesorder_positions_koestnerwarnings_noproductcertificates5(inputs)
};
export { assistantsalesorder_positions_koestnerwarnings_noproductcertificates5 as "assistantSalesOrder.positions.koestnerWarnings.noProductCertificates" }